var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCarSimple = function SvgIconCarSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.488 3.5h-.005a1.75 1.75 0 0 0-1.595 1.046L2.35 10.25H1.5a1 1 0 1 0 0 2H2v7.25a1.75 1.75 0 0 0 1.75 1.75H6a1.75 1.75 0 0 0 1.75-1.75v-1.25h8.5v1.25A1.75 1.75 0 0 0 18 21.25h2.25A1.75 1.75 0 0 0 22 19.5v-7.25h.5a1 1 0 1 0 0-2h-.85l-2.537-5.7-.001-.004A1.75 1.75 0 0 0 17.517 3.5zm12.972 6.75L17.348 5.5H6.653l-2.114 4.75zM4 12.25v7h1.75v-2a1 1 0 0 1 1-1h10.5a1 1 0 0 1 1 1v2H20v-7z",
    clipRule: "evenodd"
  })));
};
export default SvgIconCarSimple;